<div id="first-party-container" *ngIf="firstPartyBoolean$ | async; else thirdPartyInterimIsoWires">
  <mm-wire-account-number (wireAccountNumber)="getWireAccountNumber($event)" [parentForm]="parentForm" [useSloa]="useSloa" class="big-bottom-spacer"></mm-wire-account-number>
  <div>
    <mm-banners [hidden]="(showIntermediaryFields$ | async)" *ngIf="showWarningBanner()" [bannerText]="[warningAbaDescription]" [type]="'warning'"
    id="warning-banner">
    </mm-banners>
  </div>
  <span id="recipient-details-header">Recipient name and address</span>
  <div *ngIf="allowModifiedPayee" id="wire-modified-payee-section" data-testid="wire-modified-payee-section" class="big-bottom-spacer wire-modified-payee-section">
    <div id="wire-modified-payee-dropdown-section">
      <mm-select-dropdown-control [parentForm]="parentForm"
        [selectModel]="firstPartyPayeesSelectOptions" id="receivingAccountHolder_firstPartyPayeeDropdownField"
        data-testid="receivingAccountHolder_firstPartyPayeeDropdownField">
      </mm-select-dropdown-control>
      <div class="checkbox-line-container" [formGroup]="parentForm">
        <input type="checkbox" class="modified-checkbox" id="wire-inputPage-modifiedPayeeCheckbox"
          formControlName="modifiedPayeeCheckbox">
        <label class="modified-payee-label1" for="wire-inputPage-modifiedPayeeCheckbox">Use</label>
        <mm-tooltip [textTooltip]="true" [position]="'right'">
          <tooltip-content>
            <span [innerText]="modifiedPayeeTooltipVerbiage"></span>
        </tooltip-content>
        <tooltip-trigger-element>
            <span>modified recipient name</span>
        </tooltip-trigger-element>
        </mm-tooltip>
        <label class="modified-payee-label2" for="wire-inputPage-modifiedPayeeCheckbox">instead</label>
      </div>
    </div>
    <mm-wire-modified-payee *ngIf="useModifiedPayeeChecked" [parentForm]="parentForm"
      [defaultPayee]="modifiedPayeeNamesList[0]"></mm-wire-modified-payee>
  </div>
  <mm-banners *ngIf="useModifiedPayeeChecked && isJointAccount" [bannerText]="[jointRecipientBannerText]" [type]="'information'"></mm-banners>
  <div id="receivingAccountHolder_firstParty" data-testid="receivingAccountHolder_firstParty">
    <div class="prompt">Receiving account holder</div>
    <div *ngIf="useSloa">
      <div class="receiving-account-holder-line" id="receivingAccountHolder_firstPartyName1&Name2" style="white-space: pre-line;" data-testid="receivingAccountHolder_firstPartyName1&Name2">
       {{useSloaFirstPartyAddress}}</div>
    </div>
    <div *ngIf="!useSloa && !isNonIsoFirstPartyTemplate">
      <div class="receiving-account-holder-line" id="receivingAccountHolder_isoAddressLine1"
           data-testid="receivingAccountHolder_isoAddressLine1">
        {{internalReceivingAccountHolder.name}}
      </div>
      <div class="receiving-account-holder-line" id="receivingAccountHolder_isoAddressLine2"
           data-testid="receivingAccountHolder_isoAddressLine2">
        {{internalReceivingAccountHolder.accountHolderStreetNumber}}
        {{internalReceivingAccountHolder.accountHolderStreetName}}
      </div>
      <div class="receiving-account-holder-line" id="receivingAccountHolder_isoAddressLine3"
           data-testid="receivingAccountHolder_isoAddressLine3">
        {{internalReceivingAccountHolder.accountHolderApartmentSuiteEtc}} {{internalReceivingAccountHolder.department}}
        {{internalReceivingAccountHolder.buildingName}} {{internalReceivingAccountHolder.floor}}
      </div>
      <div class="receiving-account-holder-line" id="receivingAccountHolder_isoAddressLine4"
           data-testid="receivingAccountHolder_isoAddressLine4">
        {{internalReceivingAccountHolder.townLocationName}} {{internalReceivingAccountHolder.receivingBankCity}}
        {{internalReceivingAccountHolder.district}} {{internalReceivingAccountHolder.receivingBankState}}
        {{internalReceivingAccountHolder.zipCode}}
      </div>      
      <div class="receiving-account-holder-line" id="receivingAccountHolder_isoAddressLine5"
           data-testid="receivingAccountHolder_isoAddressLine5">{{internalReceivingAccountHolder.countryDescription}}</div>      
    </div>
    <div *ngIf="!useSloa && isNonIsoFirstPartyTemplate">
      <!-- Display receiving account holder details using non-ISO fields -->    
      <div class="receiving-account-holder-line" id="receivingAccountHolder_firstPartyName1&Name2" data-testid="receivingAccountHolder_firstPartyName1&Name2">
        {{nonIsoFirstPartyTemplateRecAccountHolder.accountHolderName1}} {{nonIsoFirstPartyTemplateRecAccountHolder.accountHolderName2}}</div>
      <div class="receiving-account-holder-line" id="receivingAccountHolder_firstPartyAddress1">
        {{nonIsoFirstPartyTemplateRecAccountHolder.accountHolderAddress1}}</div>
      <div class="receiving-account-holder-line" id="receivingAccountHolder_firstPartyAddress2&CountryDescription">
        {{nonIsoFirstPartyTemplateRecAccountHolder.accountHolderAddress2}} {{nonIsoFirstPartyTemplateRecAccountHolder.countryDescription}}</div>
    </div>
  </div>
</div>

<ng-template #thirdPartyInterimIsoWires>
  <mm-wire-account-number (wireAccountNumber)="getWireAccountNumber($event)" [parentForm]="parentForm" [useSloa]="useSloa" class="big-bottom-spacer"></mm-wire-account-number>
  <div>
    <mm-banners [hidden]="(showIntermediaryFields$ | async)" *ngIf="showWarningBanner()" [bannerText]="[warningAbaDescription]" [type]="'warning'"
      id="warning-banner">
    </mm-banners>
  </div>
  <div id="receivingAccountHolder_thirdParty">
    <span id="recipient-details-header">Recipient name and address</span>
    <div>
      <mm-banners [bannerText]="[warningDescription]" *ngIf="showAddressWarningBanner()" [type]="'warning'" id="wireRecipientAddressWarning_thirdParty" data-testid="wireRecipientAddressWarning_thirdParty">
      </mm-banners>
    </div>
    <div *ngIf="!isISOCompliant && useSloa">
      <div class="row">
        <!-- NAME 1 -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('name2')" [parentForm]="parentForm"
          [inputControlModel]="name2IsoModel" [errorMessage]="name2Error || ''">
        </mm-text-input-control>
        <!-- NAME 2 -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('nameCont')" [parentForm]="parentForm"
          [inputControlModel]="nameContModel" [errorMessage]="nameContError || ''">
        </mm-text-input-control>
        <!-- COUNTRY -->
        <mm-select-dropdown-control id="country-control" [parentForm]="parentForm" [selectModel]="countryListDropdown">
        </mm-select-dropdown-control>
      </div>
      <div class="row">
        <!-- ADDRESS 1 -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('address')" [parentForm]="parentForm"
          [inputControlModel]="addressModel" [errorMessage]="addressError || ''"></mm-text-input-control>
        <!-- ADDRESS 2 -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('addressCont')" [parentForm]="parentForm"
          [inputControlModel]="addressContModel" [errorMessage]="addressContError || ''"></mm-text-input-control>
      </div>
    </div>
    <div *ngIf="isISOCompliant || !useSloa">
    <div class="row">
      <!-- NAME 1 -->
      <mm-text-input-control *ngIf="!isIrsAba" class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('name1')" [parentForm]="parentForm" [inputControlModel]="name1IsoModel"
      [errorMessage]="name1Error || ''">
      </mm-text-input-control>
      <mm-text-input-control *ngIf="isIrsAba" class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('name1')" [parentForm]="parentForm" [inputControlModel]="taxPayerNameModel" [placeholder]="irsAbaPlaceholder"
      [errorMessage]="taxpayerNameError || ''">
      </mm-text-input-control>
      <!-- COUNTRY -->
      <mm-select-dropdown-control id="country-control" [parentForm]="parentForm" [selectModel]="countryListDropdown">
      </mm-select-dropdown-control>
    </div>
    <div>
      <mm-banners *ngIf="isFromTemplateAndNonIsoCompliant" [titleText]="nonIsoCompliantErrorHeader" [shouldBoldTitleText]="true" [bannerText]="[nonIsoCompliantErrorDescription]" 
        [nonIsoAddressFooter]="nonIsoCompliantErrorAddressDetails" [type]="'error'" id="nonIsoCompliantWireTemplate_recipientErrorBanner" data-testid="nonIsoCompliantWireTemplate_recipientErrorBanner">
      </mm-banners>
    </div>
    <div *ngIf="!isInternational">
      <div class="row">
        <!-- Street number -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('streetNumber')" [parentForm]="parentForm" [inputControlModel]="streetNumberModel"
          [errorMessage]="streetNumberError || ''"></mm-text-input-control>
        <!-- Street name -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('streetName')" [parentForm]="parentForm" [inputControlModel]="streetNameModel"
          [errorMessage]="streetNameError || ''"></mm-text-input-control>
        <!-- Apt/Flat, suite, etc. -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('apartmentSuiteEtc')" [parentForm]="parentForm" [inputControlModel]="apartmentSuiteModel"
          [errorMessage]="apartmentSuiteError || ''"></mm-text-input-control>
      </div>
      <div class="row">
        <!-- City -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('receivingBankCity')" [parentForm]="parentForm" [inputControlModel]="cityModel"
          [errorMessage]="cityError || ''"></mm-text-input-control>
        <!-- State -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('receivingBankState')" [parentForm]="parentForm" [inputControlModel]="stateModel"
          [errorMessage]="stateError || ''"></mm-text-input-control>
        <!-- Zip -->
        <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="zipModel"
          [errorMessage]="zipError || ''"></mm-text-input-control>
      </div> 
    </div>
    <div *ngIf="isInternational">
      <div class="row">
        <!-- Street number -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('streetNumber')" [parentForm]="parentForm" [inputControlModel]="streetNumberModel"
          [errorMessage]="streetNumberError || ''"></mm-text-input-control>
        <!-- Street name -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('streetName')" [parentForm]="parentForm" [inputControlModel]="streetNameModel"
          [errorMessage]="streetNameError || ''"></mm-text-input-control>
        <!-- Apt/Flat, suite, etc. -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('apartmentSuiteEtc')" [parentForm]="parentForm" [inputControlModel]="intlApartmentSuiteModel"
          [errorMessage]="apartmentSuiteError || ''"></mm-text-input-control>
        <!-- Zip -->
        <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="intlZipModel"
          [errorMessage]="intlZipError || ''"></mm-text-input-control>
      </div>
      <div class="extra-padding-intl-row">
        <!-- State -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('receivingBankState')" [parentForm]="parentForm" [inputControlModel]="intlStateModel"
          [errorMessage]="stateError || ''"></mm-text-input-control>
        <!-- District (international) -->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('district')" [parentForm]="parentForm" [inputControlModel]="districtModel"
          [errorMessage]="districtError || ''"></mm-text-input-control>
        <!-- City -->
        <mm-text-input-control class="input-box intl-city-height" (blur)="onBlurFieldsTrimWhiteSpace('receivingBankCity')" [parentForm]="parentForm" [inputControlModel]="intlCityModel"
          [errorMessage]="cityError || ''"></mm-text-input-control>
        <!-- Sub-locality (international)-->
        <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('townLocationName')" [parentForm]="parentForm" [inputControlModel]="townLocationNameModel"
          [errorMessage]="townLocationNameError || ''"></mm-text-input-control>
      </div> 
    </div>
    <div class="row" *ngIf="hideAddressFields == 'no'">
      <!-- Department -->
      <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('department')" [parentForm]="parentForm" [inputControlModel]="departmentModel"
      [errorMessage]="departmentError || ''"></mm-text-input-control>
      <!-- Building name -->
      <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('buildingName')" [parentForm]="parentForm" [inputControlModel]="buildingNameModel"
        [errorMessage]="buildingNameError || ''"></mm-text-input-control>
      <!-- Floor -->
      <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('floor')" [parentForm]="parentForm" [inputControlModel]="floorModel"
        [errorMessage]="floorError || ''"></mm-text-input-control>
      </div>
    </div>
  </div>
  <mm-show-hide-text-control data-testid="address-selection" [parentForm]="parentForm"
    [hideReceivingAddressFields]="hideAddressFields" [showHideTextControlModel]="intermediaryShowHideLinkModel"
    [isLinkEnabled]="!useSloa" [isIntermediary]="false" (isclosed)="isClosedAddressFields($event)">
  </mm-show-hide-text-control>
</ng-template>
